import { render, staticRenderFns } from "./DelBindEMail.vue?vue&type=template&id=33b1dab4&scoped=true&"
import script from "./DelBindEMail.vue?vue&type=script&lang=js&"
export * from "./DelBindEMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1dab4",
  null
  
)

export default component.exports